"use strict";

module.exports = function (accumulator, order, product, component, options) {
  var defaultProductTypeForPricing = component.type;
  return options.productTypeForPricing || defaultProductTypeForPricing;
};